import { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Button, Card, CardBody } from "@odingard/design-system";
import { AccessDeniedState } from "@odingard/design-system";
import { api } from "../../lib/api";
import { useAuth } from "../../lib/auth";

export function Checkout() {
  const { sessionId } = useParams<{ sessionId: string }>();
  const { activeOrg, loading } = useAuth();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  if (loading) return null;
  if (!activeOrg) {
    return (
      <div className="auth-wrap">
        <div className="auth-card">
          <AccessDeniedState reason="You must be signed in to complete checkout." />
          <p style={{ textAlign: "center" }}>
            <Link to="/login">Sign in</Link>
          </p>
        </div>
      </div>
    );
  }

  async function pay() {
    if (!sessionId || !activeOrg) return;
    setBusy(true);
    setError(null);
    try {
      await api.completeCheckout(activeOrg.id, sessionId);
      navigate("/studio/billing?welcome=1");
    } catch (e) {
      setError(e instanceof Error ? e.message : "Payment could not be completed.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="auth-wrap">
      <div className="auth-card">
        <Link to="/" className="brand" style={{ justifyContent: "center", marginBottom: "var(--ods-space-5)" }}>
          <span className="brand__mark">O</span> Odingard Studio
        </Link>
        <Card>
          <CardBody>
            <h1 style={{ fontSize: "var(--ods-text-xl)", marginTop: 0 }}>Demo checkout · preview mode</h1>
            <div className="banner banner--warning">
              🧪 Demo mode. No real payment is processed. This page simulates the Stripe provider callback so you can
              preview the whole flow from purchase to entitlement. For real purchases, use “Subscribe” on the pricing page,
              which redirects to checkout hosted by Stripe.
            </div>
            <p style={{ fontSize: "var(--ods-text-sm)", color: "var(--ods-color-muted)" }}>
              Checkout session <code>{sessionId}</code> for <strong>{activeOrg.name}</strong>. No card details are
              entered on or stored by Odingard. Clicking below provisions a simulated subscription, invoice, and
              entitlements for demonstration only.
            </p>
            {error && (
              <div className="banner banner--warning" role="alert">
                {error}
              </div>
            )}
            <Button block disabled={busy} onClick={pay}>
              {busy ? "Confirming…" : "Complete subscription"}
            </Button>
            <Button block variant="ghost" onClick={() => navigate("/pricing")}>
              Cancel
            </Button>
          </CardBody>
        </Card>
      </div>
    </div>
  );
}
